// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1HBbe","signatureBlock":"Footer_signatureBlock__1lX7c","signature":"Footer_signature__NKHHv"};